import { render, staticRenderFns } from "./GetOccupancySettings.vue?vue&type=template&id=187bbffa&"
import script from "./GetOccupancySettings.vue?vue&type=script&lang=js&"
export * from "./GetOccupancySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports